// extracted by mini-css-extract-plugin
module.exports = {"event":"index_event_14_M3"};